<div class="works">
  @for (work of works; track $index) {
    <div class="work__element {{ work.layoutClass }}" (click)="onImageClicked(work)">

      <div class="work__element-content">
        @for (workElementImage of work.images; track $index) {
          <picture class="work__img">
            <source [srcset]="workElementImage" type="image/webp" class="work__img">
            <img [src]="workElementImage" alt="{{ work.title }} image" class="work__img" appResponsiveImage>
          </picture>
          <div class="work__element-hover">
            <div class="work__element-text">{{ work.title }}</div>
          </div>
        }
      </div>
    </div>
  }
</div>

@if (isModalVisible) {
  <app-image-modal [work]="selectedWork" (close)="closeModal()"></app-image-modal>
}
